import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from "@shared/shared.module";
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { AccountDialogComponent } from './components/account-dialog/account-dialog.component';
import { LoginRoutingModule } from './login-routing.module';
import { ActivateAccountPopupComponent } from './pages/activate-account-popup/activate-account-popup.component';
import { ActivateAccountComponent } from './pages/activate-account/activate-account.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { RequestResetPasswordComponent } from './pages/request-reset-password/request-reset-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';

@NgModule({
  declarations: [
    SignInComponent,
    ActivateAccountComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AccountDialogComponent,
    SignUpComponent,
    ActivateAccountPopupComponent,
    RequestResetPasswordComponent,
  ],
  imports: [
    LoginRoutingModule,
    CommonModule,
    FontAwesomeModule,
    SharedModule,
    FormsModule,
    NgxIntlTelInputModule
  ],
  exports: [
  ]
})
export class LoginModule { }
